import { ApexOptions } from 'apexcharts';
import ReactApexChart from 'react-apexcharts';

import usePostgreSmsWidgetsData from '../../../DerivedCharts/sms/hooks/usePostgreSmsWidgetData';
import { IPostgreCommunicationDTO } from '../../jobs/types/postgreJobsDTO';
import { ISmsWidgetProp } from '../../jobs/types/postgreJobsWidgetProp';
import { defaultSmsWidgetData } from '../utils/smsHelper';

const SmsBarChartPostgre = ({ query, title }: ISmsWidgetProp) => {
  const { widgetData } = usePostgreSmsWidgetsData<IPostgreCommunicationDTO>(
    query,
    defaultSmsWidgetData
  );

  const categories = widgetData?.response?.map((record) => record.startTime);
  const bucketData = widgetData?.response?.map((record) => ({
    x: record.startTime,
    y: record.count ?? 0,
  }));

  const options: ApexOptions = {
    chart: {
      zoom: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
    },
    xaxis: {
      type: 'datetime',
      title: {
        text: title,
      },
      labels: {
        datetimeUTC: false,
      },
      categories: categories ?? [],
    },
    yaxis: {
      title: {
        text: 'Count',
      },
    },
    dataLabels: {
      enabled: false,
    },
    title: {
      text: title,
      style: {
        fontSize: '12px',
      },
    },
  };

  const series = [
    {
      data: bucketData ?? [],
      name: title,
    },
  ];

  return (
    <ReactApexChart
      options={options}
      series={series as ApexAxisChartSeries}
      type="bar"
      width="100%"
      height="100%"
    />
  );
};

export default SmsBarChartPostgre;
